<template>
  <div class="zj-layout-main-content bgcolor scrollable">
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">车源地统计</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="停车场">
            <el-select v-model="Name" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in CarparkArr"
                :key="item.Name"
                :label="item.Name"
                :value="item.Name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 60rem"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="overflow: auto">
        <div class="echart">
          <div class="echart_1">
            <div>
              车源地
              <china-map-echart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="vehicleSourceProvinceData"
              ></china-map-echart>
            </div>
          </div>
          <div class="echart_2">
            <div>
              车源地省份排行TOP10
              <barchart2
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="vehicleSourceProvinceDataTop10"
              ></barchart2>
            </div>
            <div>
              车源地省内地市排行TOP10
              <barchart2
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="vehicleSourceCityDataTop10"
              ></barchart2>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "VehicleSourceAnalysis",
  controller: "UI",
  action: "VehicleSourceAnalysis",

  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      CarparkArr: [],
      Name: "",
      leftPlaceData: { maxData: 1000, data: 300 },
      vehicleSourceProvinceDataTop10: { days: [], data: [] },
      vehicleSourceCityDataTop10: { days: [], data: [] },
      vehicleSourceProvinceData: [],
      date_start: undefined,
      date_end: undefined,
      date: [new Date(), new Date()],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今年",
            onClick(picker) {
              const end = new Date();
              let start = new Date();
              start = new Date(start.getFullYear() + "-" + "01" + "-" + "01");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted: function () {
    this.getCarpark();
    this.onSearch();
  },
  methods: {
    //获取所有停车场
    getCarpark() {
      let searchInfo = {
        PageSize: 20,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let sumPlace = 0,
            leftPlace = 0;
          this.CarparkArr = r.PageContents;
          this.CarparkArr.forEach((item) => {
            sumPlace += item.TotalPlace;
            leftPlace += item.LeftPlace;
          });
          this.leftPlaceData.maxData = sumPlace;
          this.leftPlaceData.data = leftPlace;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //获取所有停车场
    getCarparkByName() {
      let searchInfo = {
        Name: this.Name,
        PageSize: 20,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let sumPlace = 0,
            leftPlace = 0;
          r.PageContents.forEach((item) => {
            sumPlace += item.TotalPlace;
            leftPlace += item.LeftPlace;
          });
          this.leftPlaceData.maxData = sumPlace;
          this.leftPlaceData.data = leftPlace;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onSearch() {
      this.getCarparkByName();
      this.findProvinceCount();
      this.findProvinceCountTop10();
      this.findCityCountTop10();
    },
    //车源地省份排行
    findProvinceCount() {
      let searchInfo = {
        ParkName: this.Name,
        StartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        EndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
      };
      new MyApis.CarParkBigDataApi()
        .FindProvinceCount(searchInfo)
        .then((r) => {
          r = r.data.Data;

          r.forEach((item) => {
            if (item.ItemKey != "吉林省") {
              this.vehicleSourceProvinceData.push([
                { name: item.ItemKey, value: item.ItemValue },
              ]);
            }
          });
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //车源地省份排行TOP10
    findProvinceCountTop10() {
      let searchInfo = {
        ParkName: this.Name,
        StartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        EndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
      };

      new MyApis.CarParkBigDataApi()
        .FindProvinceCountTop10(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let days = [],
            data = [];
          r.forEach((item) => {
            days.push(item.ItemKey);
            data.push(item.ItemValue);
          });
          this.vehicleSourceProvinceDataTop10 = {
            days: days,
            data: data,
          };
          // this.trafficFlowTrendDataByDay =
          //   this.trafficFlowTrendDataByDay.sort(this.sortData);
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //车源地地市排行TOP10
    findCityCountTop10() {
      let searchInfo = {
        ParkName: this.Name,
        StartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        EndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
      };

      new MyApis.CarParkBigDataApi()
        .FindCityCountTop10(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let days = [],
            data = [];
          r.forEach((item) => {
            days.push(item.ItemKey);
            data.push(item.ItemValue);
          });
          this.vehicleSourceCityDataTop10 = {
            days: days,
            data: data,
          };
          // this.trafficFlowTrendDataByDay =
          //   this.trafficFlowTrendDataByDay.sort(this.sortData);
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    findCarCountByYear() {
      let searchInfo = {
        ParkName: this.Name,
        StartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        EndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
      };
      //Wifi使用人数、时段
      new MyApis.CarParkBigDataApi()
        .FindCarCountByMonth(searchInfo)
        .then((r) => {
          r = r.data.Data;
          let days = [],
            data = [];
          r.forEach((item) => {
            days.push(item.ItemKey);
            data.push(item.ItemValue);
          });
          this.trafficFlowTrendDataByYear = {
            days: days,
            data: data,
          };
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },

    sortData(a, b) {
      return b.data - a.data;
    },
  },
};
</script>
<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 48rem;
}
.echart_1 {
  margin-bottom: 15px;
}
.echart_2 {
  margin-top: 15px;
}
.echart_1 > div {
  float: left;
  width: 100%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>